/**
 * Pure catalog link builders shared by the real bidder site and the onboarding
 * preview surface (Phase E1). Centralizing them keeps a single contract:
 *
 *   basePath = ''               → real site:   /auctions, /auctions/:slug, ...
 *   basePath = '/preview/<slug>' → preview:     /preview/<slug>/auctions, ...
 *
 * The empty-basePath outputs MUST stay byte-identical to the pre-E1 hardcoded
 * paths (see previewNav.test.ts) so the live bidder site is unaffected.
 */

/** Base path for a tenant's onboarding preview subtree. */
export function previewBasePath(tenantSlug: string): string {
  return `/preview/${tenantSlug}`;
}

/** The catalog list (`/auctions`). */
export function auctionsListPath(basePath: string): string {
  return `${basePath}/auctions`;
}

/** A single auction's detail page. */
export function auctionPath(basePath: string, auctionSlug: string): string {
  return `${basePath}/auctions/${auctionSlug}`;
}

/** A single lot's detail page (only reachable on the real site, not in preview). */
export function lotPath(basePath: string, auctionSlug: string, lotNumber: number | string): string {
  return `${basePath}/auctions/${auctionSlug}/lots/${lotNumber}`;
}
